import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ProtectedRoute from "./components/ProtectedRoute";
import GuestRoute from "./components/GuestRoute";

import Login from "./pages/Login";
import Signup from "./pages/Signup";
import AuthLayout from "./layouts/AuthLayout";
import Dashboard from "./pages/Dashboard";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import NewPassword from "./pages/NewPassword";
import Events from "./pages/Events";
import Search from "./pages/Search";
import Resources from "./pages/Resources";
import Donate from "./pages/Donate";
import Testimony from "./pages/Testimony";
import Prayer from "./pages/Prayer";
import Feedback from "./pages/Feedback";
import Settings from "./pages/Settings";
import PrayerHistory from "./pages/PrayerHistory";
import TestimonyHistory from "./pages/TestimonyHistory";
import DonateHistory from "./pages/DonateHistory";
import Profile from "./pages/Profile";
import Notification from "./pages/Notification";
import EventDetails from "./pages/EventDetails";
import SearchProfile from "./pages/SearchProfile";
import Volunteering from "./pages/Volunteering";
import SinglesFellowship from "./pages/SinglesFellowship";
import ResourcesArticle from "./pages/ResourcesArticle";
import AllResources from "./pages/AllResources";
import AllVolunteer from "./pages/AllVolunteer";
import ManageSignUp from "./pages/ManageSignUp";
import MyProfileSettings from "./pages/MyProfileSettings";
import Error404 from "./pages/Error404";
import VerifyEmail from "./pages/VerifyEmail";
import { useAuthInterceptor } from "./components/useAuthInterceptor";

function App() {
  useAuthInterceptor();
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events"
          element={
            <ProtectedRoute>
              <Events />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/search"
          element={
            <ProtectedRoute>
              <Search />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/resources"
          element={
            <ProtectedRoute>
              <Resources />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/allresources"
          element={
            <ProtectedRoute>
              <AllResources />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/resources-article/:id"
          element={
            <ProtectedRoute>
              <ResourcesArticle />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/donate"
          element={
            <ProtectedRoute>
              <Donate />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/testimony"
          element={
            <ProtectedRoute>
              <Testimony />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/prayer"
          element={
            <ProtectedRoute>
              <Prayer />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/feedback"
          element={
            <ProtectedRoute>
              <Feedback />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/myprofilesettings"
          element={
            <ProtectedRoute>
              <MyProfileSettings />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/prayerhistory"
          element={
            <ProtectedRoute>
              <PrayerHistory />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/testimonyhistory"
          element={
            <ProtectedRoute>
              <TestimonyHistory />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/donatehistory"
          element={
            <ProtectedRoute>
              <DonateHistory />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/notification"
          element={
            <ProtectedRoute>
              <Notification />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/eventdetails/:slug"
          element={
            <ProtectedRoute>
              <EventDetails />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/searchprofile/:id"
          element={
            <ProtectedRoute>
              <SearchProfile />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/volunteering"
          element={
            <ProtectedRoute>
              <Volunteering />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/allvolunteer"
          element={
            <ProtectedRoute>
              <AllVolunteer />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/managesignup"
          element={
            <ProtectedRoute>
              <ManageSignUp />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/singlesfellowship"
          element={
            <ProtectedRoute>
              <SinglesFellowship />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path="/login"
          element={
            <GuestRoute>
              <AuthLayout>
                <Login />
                <ToastContainer
                  position="top-right"
                  autoClose={1500}
                  hideProgressBar={false}
                />
              </AuthLayout>
            </GuestRoute>
          }
        />
        <Route
          path="/signup"
          element={
            <GuestRoute>
              <AuthLayout>
                <Signup />
                <ToastContainer
                  position="top-right"
                  autoClose={1500}
                  hideProgressBar={false}
                />
              </AuthLayout>
            </GuestRoute>
          }
        />

        <Route
          path="/forgot-password"
          element={
            <AuthLayout>
              <ForgotPassword />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </AuthLayout>
          }
        />
        <Route
          path="/reset-password"
          element={
            <AuthLayout>
              <ResetPassword />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </AuthLayout>
          }
        />
        <Route
          path="/new-password"
          element={
            <AuthLayout>
              <NewPassword />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </AuthLayout>
          }
        />
        <Route
          path="/verify-email"
          element={
            <AuthLayout>
              <VerifyEmail />
              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
              />
            </AuthLayout>
          }
        />
        <Route path="*" element={<Error404 />} />
      </Routes>

      <ToastContainer position="top-right" autoClose={1500} />
    </>
  );
}

export default App;
